import { rdb } from './initialise'
import { ref } from 'firebase/database'

export const getPositions = () => {
    const posRef = ref(rdb, 'positions')
    return posRef
}
